// Simulação de toque do UAT (só age dentro do iframe de celular/tablet): precisa
// ser o primeiro import, para ajustar matchMedia e folhas de estilo antes do resto.
import "./utils/uatTouchEmulation";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import moment from "moment";
import "moment/locale/pt-br";
import "./index.css";
import "./theme-dark.css";
import "./styles/animations.css";
import "./styles/datepicker.css";
import "./styles/light-contrast.css";
import AppRouter from "./routes/AppRouter";
import { PermissionProvider } from "./contexts/ApplicationContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import DialogHost from "./components/common/DialogHost";
import SelectTray from "./components/common/SelectTray";
import DatePickerHost from "./components/datepicker/DatePickerHost";
import UatThemeShortcut from "./components/common/UatThemeShortcut";
import UatViewportShortcut from "./components/common/UatViewportShortcut";
import "react-quill/dist/quill.snow.css";
import 'quill-mention/dist/quill.mention.css';
// Registra o interceptor que limpa o cache do board a cada escrita de funil ou
// etapa. Importado aqui porque o "Gerenciar funis" é rota lazy separada do
// board: se dependesse do CRMTable estar carregado, o interceptor não existiria
// justamente na tela onde o funil é editado.
import "./utils/crmRefCache";

// Locale pt-BR global para o moment (meses/dias em português em todo o app,
// independente da ordem de carregamento dos chunks).
moment.locale("pt-br");

const removeLoadingSpinner = () => {
  const loadingContainer = document.getElementById("loading-container");
  if (!loadingContainer) return;
  loadingContainer.classList.add("lc-hiding");
  setTimeout(() => {
    loadingContainer.style.display = "none";
  }, 500);
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <PermissionProvider>
      <ThemeProvider>
        <AppRouter />
        <DialogHost />
        <SelectTray />
        <DatePickerHost />
        <UatThemeShortcut />
        <UatViewportShortcut />
      </ThemeProvider>
    </PermissionProvider>
  </QueryClientProvider>
);

window.addEventListener("load", removeLoadingSpinner);
